<div
  class="offcanvas-header border-bottom p-3 bg-white d-flex align-items-center justify-content-between"
>
  <div class="d-flex align-items-center gap-2">
    <div
      class="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center flex-shrink-0"
      style="width: 38px; height: 38px"
    >
      <i class="ph ph-bell fs-5"></i>
    </div>
    <div>
      <div class="d-flex align-items-center gap-2">
        <h6 class="offcanvas-title mb-0 fw-bold text-dark">Notifications</h6>
        @if (unreadCount > 0) {
          <span
            class="badge bg-danger rounded-pill px-2 py-1"
            style="font-size: 0.7rem"
            >{{ unreadCount }} new</span
          >
        }
      </div>
      <small class="text-secondary" style="font-size: 0.75rem"
        >Stay updated with latest activities</small
      >
    </div>
  </div>

  <div class="d-flex align-items-center gap-2 ms-auto">
    @if (unreadCount > 0) {
      <button
        type="button"
        class="btn btn-sm btn-link text-primary text-decoration-none fw-medium p-0 text-nowrap d-flex align-items-center gap-1 me-1"
        style="font-size: 0.75rem"
        (click)="markAllAsRead()"
      >
        <i class="ph ph-check-square fs-6"></i>
        <span>Mark read</span>
      </button>
    }
    <button
      type="button"
      class="btn-close ms-1"
      aria-label="Close"
      (click)="activeOffcanvas.dismiss('Cross click')"
    ></button>
  </div>
</div>

<!-- Notifications Body Container with Padded Card Boxes -->
<div
  class="offcanvas-body p-3 bg-body-tertiary overflow-y-auto overflow-x-hidden"
  style="height: calc(100vh - 75px); max-height: calc(100vh - 75px)"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="300"
  [scrollWindow]="false"
  (scrolled)="onScroll()"
>
  @if (notifications.length > 0) {
    <div class="d-flex flex-column gap-2 w-100">
      @for (item of notifications; track item.id) {
        <div
          class="card border rounded-3 p-3 shadow-sm transition-all w-100"
          [class.bg-white]="item.read"
          [class.border-light-subtle]="item.read"
          [class.bg-white]="!item.read"
          [class.border-primary-subtle]="!item.read"
          [class.border-start]="!item.read"
          [class.border-4]="!item.read"
          [class.border-primary]="!item.read"
          (click)="onNotificationClick(item)"
          style="
            cursor: pointer;
            overflow-wrap: anywhere;
            word-break: break-word;
          "
        >
          <div class="d-flex gap-3 align-items-start w-100">
            <!-- Icon Avatar -->
            <div
              class="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style="width: 40px; height: 40px"
              [class.bg-info-subtle]="item.type === 'info'"
              [class.text-info]="item.type === 'info'"
              [class.bg-success-subtle]="item.type === 'success'"
              [class.text-success]="item.type === 'success'"
              [class.bg-warning-subtle]="item.type === 'warning'"
              [class.text-warning]="item.type === 'warning'"
              [class.bg-danger-subtle]="item.type === 'danger'"
              [class.text-danger]="item.type === 'danger'"
            >
              <i class="ph" [ngClass]="item.icon + ' fs-5'"></i>
            </div>

            <!-- Card Content -->
            <div
              class="flex-grow-1 min-w-0"
              style="overflow-wrap: anywhere; word-break: break-word"
            >
              <div
                class="d-flex align-items-start justify-content-between gap-2 mb-1"
              >
                <h6
                  class="mb-0 text-wrap text-dark flex-grow-1"
                  [class.fw-bold]="!item.read"
                  [class.fw-semibold]="item.read"
                  style="
                    font-size: 0.85rem;
                    line-height: 1.35;
                    overflow-wrap: anywhere;
                    word-break: break-word;
                  "
                >
                  {{ item.title }}
                </h6>

                <div class="d-flex align-items-center gap-1 flex-shrink-0 ms-1">
                  <span
                    class="text-secondary text-nowrap"
                    style="font-size: 0.72rem"
                    >{{ item.time }}</span
                  >
                  @if (!item.read) {
                    <span
                      class="bg-primary rounded-circle d-inline-block ms-1"
                      style="width: 7px; height: 7px"
                    ></span>
                  }
                </div>
              </div>

              <p
                class="text-secondary mb-2 text-wrap"
                style="
                  font-size: 0.78rem;
                  line-height: 1.45;
                  white-space: pre-line;
                  overflow-wrap: anywhere;
                  word-break: break-word;
                "
              >
                {{ item.message }}
              </p>

              <div
                class="d-flex align-items-center justify-content-between pt-1"
              >
                <!-- Type Pill Badge -->
                <span
                  class="badge rounded-pill fw-semibold text-uppercase"
                  style="font-size: 0.65rem; padding: 0.3em 0.75em"
                  [class.bg-info-subtle]="item.type === 'info'"
                  [class.text-info-emphasis]="item.type === 'info'"
                  [class.bg-success-subtle]="item.type === 'success'"
                  [class.text-success-emphasis]="item.type === 'success'"
                  [class.bg-warning-subtle]="item.type === 'warning'"
                  [class.text-warning-emphasis]="item.type === 'warning'"
                  [class.bg-danger-subtle]="item.type === 'danger'"
                  [class.text-danger-emphasis]="item.type === 'danger'"
                >
                  {{ item.type }}
                </span>

                <!-- Quick Action Buttons -->
                <div class="d-flex align-items-center gap-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-light rounded-circle p-0 d-flex align-items-center justify-content-center"
                    style="width: 28px; height: 28px"
                    [title]="item.read ? 'Read' : 'Mark as read'"
                    (click)="toggleReadStatus(item, $event)"
                  >
                    <i
                      class="ph text-secondary fs-6"
                      [class.ph-envelope-simple-open]="item.read"
                      [class.ph-envelope-simple]="!item.read"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (isLoading) {
        <div class="text-center py-2">
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }
    </div>
  } @else {
    @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else {
      <!-- Empty State Card -->
      <div class="card border-0 shadow-sm p-5 text-center my-4 rounded-3">
        <div
          class="rounded-circle bg-light p-4 mb-3 mx-auto d-flex align-items-center justify-content-center"
          style="width: 80px; height: 80px"
        >
          <i class="ph ph-bell-slash text-muted display-6"></i>
        </div>
        <h6 class="fw-bold mb-1 text-dark">No notifications</h6>
        <p class="text-secondary fs-7 mb-0">
          You are all caught up! No notifications to display.
        </p>
      </div>
    }
  }
</div>
